<div class="root-container">
    <div class="invite-box">
        <div *ngIf=" !((inviteLoading$ | async ) || ( inviteSuccess$ | async )) && decodedMessage">
            <div class="invite-header">
                <div class="logo">
                    <i class="icon-smash_icologo_chip"></i>
                </div>
                <h1 class="title" translate>INVITE_TITLE</h1>
            </div>
            <form [formGroup]="invitationForm" class="invite-form" (ngSubmit)="onSubmit()">
                <div *ngIf="decodedMessage.senderEmail" class="invite-body">
                    <p translate [translateParams]='{email: decodedMessage.senderEmail }'>INVITE_TEXT</p>
                </div>
                <div class="input-container">
                    <app-smash-input type="username" [disabled]="true" [readonly]="true"
                        placeholder="{{ 'INVITE_PLACEHOLDER_USERNAME' | translate }}" formControlName="username">
                    </app-smash-input>
                </div>
                <div class="input-container">
                    <app-smash-input type="password" placeholder="{{ 'INVITE_PLACEHOLDER_PASSWORD' | translate }}"
                        formControlName="password" [error]="submitted && f.password.invalid">
                        <div *ngIf="!!(inviteError$ | async)" error>{{ ( inviteError$ | async | translate ) }}</div>
                        <div *ngIf="submitted && f.password.invalid" error translate>UPLOADER_CONFIG_SMASH_SUBTITLE_PASSWORD_ERROR</div>
                    </app-smash-input>
                </div>
                <div class="invite-form-footer">
                    <div></div>
                    <button class="btn larger red" type="submit" translate>INVITE_BUTTON_LABEL_CREATE_ACCOUNT</button>
                </div>
            </form>
        </div>
        <!-- loading -->
        <div *ngIf="(inviteLoading$ | async ) || ( inviteSuccess$ | async ) ">
            <div class="spinner-container">
                <div class="loading-spinner-grey"></div>
            </div>
        </div>
        <!-- invite token expired error  -->
        <div *ngIf="(inviteTokenExpired$ | async) === true ">
            <div class="invite-header">
				<div class="logo">
					<i class="icon-smash_icologo_chip"></i>
				</div>
				<h1 class="title">{{'INVITE_TOKEN_EXPIRED_TITLE' | translate}}</h1>
			</div>
            <div class="invite-body">
				{{ 'INVITE_TOKEN_EXPIRED_BODY' | translate}}
			</div>
        </div>
        <!-- invite token invalid error  -->
		 <div *ngIf="(inviteTokenInvalid$ | async)">
			<div class="invite-header">
				<div class="logo">
					<i class="icon-smash_icologo_chip"></i>
				</div>
				<h1 class="title">{{'INVITE_TOKEN_INVALID_TITLE' | translate}}</h1>
			</div>
			<div class="invite-body">
				{{ 'INVITE_TOKEN_INVALID_BODY' | translate}}
			</div>
		 </div>
    </div>
</div>